<template>
  <div>
    <a href="#" class="link -color" @click.prevent="modalOpen=true">Ver JSON</a>
    <modal size="large" v-if="modalOpen" @close-modal="closeModal">
      <div slot="header">
        JSON do Callback
      </div>

      <div slot="content">
        <pre><code>{{ json }}</code></pre>
      </div>

      <div slot="footer">
      </div>

    </modal>
  </div>
</template>

<script>
  export default {
    props: ['json'],
    data() {
      return {
        modalOpen: false
      }
    },
    methods: {
      closeModal() {
        this.modalOpen = false;
      }
    }
  }
</script>

<style scoped>
  pre {
    font-size: 14px;
  }
</style>
